import Vue from 'vue2'
import VueI18n from 'vue2-i18n'
import id from '@/i18n/id.json'
import en from '@/i18n/en.json'
import { getLocale } from '@/utils/common'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'ID',
  messages: {
    ID: id,
    EN: en
  }
})

export default i18n
